"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _objectHash = _interopRequireDefault(require("object-hash"));

var _ExperimentContext = require("../context/ExperimentContext");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var useFetchExperimentData = function useFetchExperimentData() {
  var _useExperimentContext = (0, _ExperimentContext.useExperimentContext)(),
      actions = _useExperimentContext.actions,
      selectors = _useExperimentContext.selectors,
      fetchExperiments = _useExperimentContext.fetchExperiments,
      errorHandler = _useExperimentContext.errorHandler;

  var setLoadingState = actions.setLoadingState,
      updateExperiments = actions.updateExperiments,
      replaceExperiments = actions.replaceExperiments,
      updateExperimentCache = actions.updateExperimentCache;
  var getState = selectors.getState,
      getFromCache = selectors.getFromCache,
      getSegmentationState = selectors.getSegmentationState;

  var _getState = getState(),
      experiments = _getState.experiments,
      experimentCache = _getState.experimentCache;

  return (0, _react.useCallback)(
  /*#__PURE__*/
  function () {
    var _ref = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee() {
      var _ref2,
          _ref2$payloadData,
          payloadData,
          _ref2$invalidate,
          invalidate,
          forceFetch,
          cacheHash,
          valueInCache,
          updatedExperiments,
          experimentResponse,
          _args = arguments;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _ref2 = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, _ref2$payloadData = _ref2.payloadData, payloadData = _ref2$payloadData === void 0 ? {} : _ref2$payloadData, _ref2$invalidate = _ref2.invalidate, invalidate = _ref2$invalidate === void 0 ? [] : _ref2$invalidate, forceFetch = _ref2.forceFetch;
              _context.prev = 1;
              cacheHash = (0, _objectHash.default)(payloadData);
              valueInCache = getFromCache(cacheHash);

              if (!(valueInCache && !forceFetch)) {
                _context.next = 8;
                break;
              }

              updateExperiments(valueInCache);
              _context.next = 15;
              break;

            case 8:
              setLoadingState(true);

              if (invalidate.length > 0) {
                updatedExperiments = invalidate.reduce(function (acc, current) {
                  delete acc[current];
                  return acc;
                }, _objectSpread({}, experiments));
                replaceExperiments(updatedExperiments);
              }

              _context.next = 12;
              return fetchExperiments(_objectSpread({}, payloadData, {
                experimentData: _objectSpread({}, getSegmentationState().experimentData, {}, payloadData.experimentData)
              }));

            case 12:
              experimentResponse = _context.sent;
              updateExperiments(experimentResponse);
              updateExperimentCache(_defineProperty({}, cacheHash, experimentResponse));

            case 15:
              _context.next = 24;
              break;

            case 17:
              _context.prev = 17;
              _context.t0 = _context["catch"](1);

              if (!errorHandler) {
                _context.next = 23;
                break;
              }

              errorHandler(_context.t0);
              _context.next = 24;
              break;

            case 23:
              throw _context.t0;

            case 24:
              _context.prev = 24;
              setLoadingState(false);
              return _context.finish(24);

            case 27:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 17, 24, 27]]);
    }));

    return function () {
      return _ref.apply(this, arguments);
    };
  }(), [experiments, experimentCache]);
};

var _default = useFetchExperimentData;
exports.default = _default;